import { createMmWsAction } from '@skynet/data-ws-mm';
import { BalanceHistoryCommands } from './types';
import type {
  SetInitialBalancePayload,
  PayloadGetBalanceHistory,
  ResetInitialBalancePayload,
} from './types';

export const getBalanceHistoryWs = createMmWsAction<PayloadGetBalanceHistory>(
  'retainers/GetBalanceHistoryWs',
  BalanceHistoryCommands.GetBalanceHistory,
);

export const setInitialBalance = createMmWsAction<
  SetInitialBalancePayload,
  SetInitialBalancePayload
>(
  'retainers/SetInitialBalance',
  (
    data = {
      accountID: 0,
      token: '',
      amount: 0,
    },
  ) => ({
    command: BalanceHistoryCommands.SetInitialBalance,
    ...data,
  }),
);

export const resetInitialBalance = createMmWsAction<
  ResetInitialBalancePayload,
  ResetInitialBalancePayload
>(
  'resetInitialBalance',
  (
    data = {
      accountID: 0,
      token: '',
      date: '',
    },
  ) => ({
    command: BalanceHistoryCommands.ResetInitialBalance,
    ...data,
  }),
);
